import React, { useContext, useEffect, useState } from 'react';
import { useFormik } from 'formik';

// Layout & Components
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Select from '../../bootstrap/forms/Select';
import Button from '../../bootstrap/Button';
import { CardBody } from '../../bootstrap/Card';
import BtnLoad from '../../MyCustom/BtnLoad';

// Context & Services
import { DefaultContext } from '../../../contexts/default';
import PreAlert from '../../../helpers/utils/preAlert';
import InsumosDB from '../../../database/wrappers/insumos';
import { UNIT_OPTIONS } from '../../../types/unitTypes';

// Validation
const validate = (values) => {
    const errors = {};
    if (!values.type) errors.type = 'Este campo é necessário';
    if (!values.name) errors.name = 'Este campo é necessário';
    if (!values.unit) errors.unit = 'Este campo é necessário';
    return errors;
};

const ModalRegisterInsumo = ({ open, handleOpen, insumoSelected }) => {
    const { estabSelected, onShowAlert } = useContext(DefaultContext);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            type: '',
            name: '',
            sku: '',
            unit: '',
        },
        validate,
        onSubmit: async (values) => {
            setIsLoading(true);
            const { name, type, sku, unit } = values;

            const data = {
                name,
                type,
                unit,
                ...(sku && { sku })
            }

            const onSuccess = () => {
                onShowAlert(PreAlert.success('Registro cadastrado com sucesso'));
                handleOpen();
            };

            const onSuccessUpdate = () => {
                onShowAlert(PreAlert.success('Registro atualizado com sucesso'));
                handleOpen();
            };

            const onError = (_error) => {
                onShowAlert(PreAlert.error('Falhou ao cadastrar o registro'));
            };

            const insumosDB = new InsumosDB(estabSelected);
            try {
                if (!insumoSelected) {
                    await insumosDB.create(data);
                    onSuccess();
                } else {
                    await insumosDB.update(insumoSelected.id, data);
                    onSuccessUpdate();
                }
            } catch (error) {
                onError(error);
            } finally {
                setIsLoading(false);
            }
        },
    });

    useEffect(() => {
        if (open) {
            if (insumoSelected) {
                const { type, name, sku, unit } = insumoSelected;
                formik.setValues({ type, name, sku, unit });
            } else {
                formik.resetForm();
            }
        }
    }, [open, insumoSelected]);

    return (
        <Modal
            isOpen={open}
            setIsOpen={handleOpen}
            isStaticBackdrop
            isScrollable={false}
            isCentered
            size="lg"
            isAnimation
            onSubmit={formik.handleSubmit}
        >
            <ModalHeader className="p-4 mt-2 justify-content-start" setIsOpen={handleOpen}>
                <ModalTitle>
                    {insumoSelected?.id ? 'Atualização de insumo' : 'Cadastro de insumo'}
                </ModalTitle>
            </ModalHeader>
            <ModalBody className="p-5">
                <form noValidate onSubmit={formik.handleSubmit}>
                    <CardBody className="p-0">
                        <div className="row gap-4">
                            <div className="row pb-2 d-flex">
                                {/* Nome */}
                                <FormGroup id="name" label="Nome" className="col-md-12 mb-4">
                                    <Input
                                        {...formik.getFieldProps('name')}
                                        isValid={formik.isValid}
                                        isTouched={formik.touched.name}
                                        invalidFeedback={formik.errors.name}
                                        validFeedback="Assim está bom!"
                                        placeholder=""
                                    />
                                </FormGroup>

                                {/* Tipo */}
                                <FormGroup id="type" label="Tipo" className="col-md-4 mb-4">
                                    <Input
                                        {...formik.getFieldProps('type')}
                                        isValid={formik.isValid}
                                        isTouched={formik.touched.type}
                                        invalidFeedback={formik.errors.type}
                                        validFeedback="Assim está bom!"
                                        placeholder=""
                                    />
                                </FormGroup>

                                {/* Unidade */}
                                <FormGroup id="unit" label="Unidade" className="col-md-4 mb-4">
                                    <Select
                                        placeholder="Selecione o tipo"
                                        list={UNIT_OPTIONS}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.unit}
                                    />
                                </FormGroup>

                            </div>
                        </div>
                    </CardBody>

                    <div className="row pt-4">
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                color="danger"
                                icon="cancel"
                                rounded={1}
                                onClick={handleOpen}
                                shadow="sm"
                                hoverShadow="sm"
                                size="sm"
                            >
                                Cancelar
                            </Button>

                            {isLoading ? (
                                <BtnLoad />
                            ) : (
                                <Button
                                    isDisable={!formik.isValid && !!formik.submitCount}
                                    type="submit"
                                    color="success"
                                    icon="check"
                                    rounded={1}
                                    hoverShadow="sm"
                                    shadow="sm"
                                    size="sm"
                                >
                                    Salvar
                                </Button>
                            )}
                        </div>
                    </div>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default ModalRegisterInsumo;
